import React, { useEffect, useRef, useState } from 'react';
import { FaBars, FaTimes } from 'react-icons/fa';
import { Link } from 'react-scroll';
import { gsap } from 'gsap';
import { useTranslation } from 'react-i18next';

const Navbar = () => {
	const [nav, setNav] = useState(false);
	const ref = useRef();
	const navRef = useRef();
	const { t, i18n } = useTranslation('translation', {
		keyPrefix: 'navbar',
	});

	const links = [
		{ id: 1, link: t('main'), name: 'home' },
		{ id: 2, link: t('about'), name: 'about' },
		{ id: 3, link: t('portfolio'), name: 'portfolio' },
		{ id: 4, link: t('expirience'), name: 'experience' },
		{ id: 5, link: t('contact'), name: 'contact' },
	];

	const valueLng = [
		{ Id: 1, value: 'ru', name: 'RU' },
		{ Id: 2, value: 'en', name: 'EN' },
	];

	useEffect(() => {
		let ctx = gsap.context(() => {
			gsap.to(ref.current, {
				rotation: '+=360',
				delay: 0.5,
			});
			gsap.fromTo(
				navRef.current,
				{ height: 200 },
				{ duration: 1.5, height: 30 }
			);
		});

		return () => ctx.revert();
	}, []);

	const handleChangeLng = (e) => {
		i18n.changeLanguage(e.target.value);
	};

	return (
		<header
			className='flex justify-between items-center w-full px-4 h-20 bg-black
     text-white fixed z-10'
		>
			<div>
				<h1 ref={ref} className='text-5xl font-signature ml-2 cursor-pointer'>
					<Link to='home'>Kostya</Link>
				</h1>
			</div>
			<ul ref={navRef} className='hidden md:flex'>
				{links.map(({ link, id, name }) => (
					<li
						key={id}
						className='px-4 cursor-pointer capitalize font-medium text-gray-500 
            hover:scale-105 duration-200'
					>
						<Link to={name} smooth duration={500}>
							{link}
						</Link>
					</li>
				))}
				<li>
					<select className='bg-black text-white' onChange={handleChangeLng}>
						{valueLng.map((lng) => (
							<option key={lng.id} value={lng.value}>
								{lng.name}
							</option>
						))}
					</select>
				</li>
			</ul>

			<div
				onClick={() => setNav(!nav)}
				className='cursor-pointer pr-4 z-10 text-gray-500 md:hidden'
			>
				{nav ? <FaTimes size={30} /> : <FaBars size={30} />}
			</div>

			{nav && (
				<ul
					className='flex flex-col justify-center items-center absolute top-0 left-0 
				w-full h-screen bg-gradient-to-b from-black to-gray-800 text-gray-500'
				>
					{links.map(({ link, id }) => (
						<li
							key={id}
							className='px-4 cursor-pointer capitalize py-6 text-4xl'
						>
							<Link to={link} smooth duration={500}>
								{link}
							</Link>
						</li>
					))}
				</ul>
			)}
		</header>
	);
};

export default Navbar;
